import { CallServices } from "../../base/service/apiServices";
import { ChatActions } from "../../store/slices/chat_slice/chat_slice";
import ChatLeftSideBar from "./chatWidgets/chatLeftSidebar";
import ChatMainInner from "./chatWidgets/chatMainInner";
import ChatRightSideBar from "./chatWidgets/chatRightSidebar";
import { Layout } from "antd";
import moment from "moment";
import store from "../../store/redux-store/root_store";
import { useDispatcher } from "../../custom_hooks/use_app_dispatch";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ViewInteractions from "./viewInteractionsold";
import MeetTranscription from "../joinMeetingScreen/meetTranscription";
import VideoMeetingChat from "../joinMeetingScreen/meetChat";
import { CALLURL } from "../../constants/api_constants";
import { GetItemFromStorage } from "../../custom_hooks/useStorage";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import { useMediaQuery } from "react-responsive";
import { CallService } from "../../services/call_service";
import { PRIVILLEGED_ROLES, ROLES } from "../../base/constant";

function WebChatScreen() {
  const { Sider, Content } = Layout;
  const meetReducer: any = useSelector((state: any) => state.meetingReducer);
  let { componentState, agentvideo } = store.getState().meetingReducer;
  const { closeCaptionText } = store.getState().closeCaption;
  const chatReducer: any = useSelector((state: any) => state.chatReducer);
  const loginUserCcaasDetail = GetItemFromStorage(LocalStorage.USER_DETAILS);
  const loginDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  const { dispositionTagList } = useSelector((state: any) => state.contactListForAgent);
  let { currentSession } = chatReducer;
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  const { SupervisorEndCall } = CallService(dispatch, navigate);
  const roleId = GetItemFromStorage(LocalStorage.ROLE_ID);

  const popUpDetails: any = store.getState().callPopUpDetails;
  let { incomingCallDetail } = popUpDetails;
  const getData = () => {
    let chatBynumberData = { number: chatReducer.currentSession.Number };
    CallServices.post(chatBynumberData, "/get_chatByNumber").then((resp: any) => {
      mapFunction(resp.data.result);
    });
  };

  const mapFunction = (totalVal: any) => {
    totalVal.map((values: any, index: any) => {
      let momentdate: any = moment(values.sessionStartTime * 1000).format("DD-MM-YYYY");
      const yesterday = moment().subtract(1, "day").format("DD-MM-YYYY");
      const today = moment().format("DD-MM-YYYY");

      if (momentdate === today) {
        totalVal[index].day = "Today";
      } else if (momentdate === yesterday) {
        totalVal[index].day = "Yesterday";
      } else {
        totalVal[index].day = momentdate;
      }
    });
    dispatch(ChatActions.setInteraction(totalVal));
  };

  const mapData = (data: any) => {
    return {
      colorCode: data.colorCode,
      description: data.description,
      did: data.did,
      dispositionName: data.dispositionName,
      domainId: data.domainId,
      status: data.status,
      type: data.type,
      updateAt: new Date(),
      loginUser: loginUserCcaasDetail.profileName
    };
  };
  console.log('agent_work_space_history', chatReducer.agent_work_space_history, currentSession)
  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      event.preventDefault();
      event.returnValue = "Are you sure you want to leave?";
    };

    const handleUnload = () => {

      if ((incomingCallDetail ? Object.keys(incomingCallDetail).length : 0) > 0) {
        SupervisorEndCall(incomingCallDetail?.useragent)
      }
      const dis = dispositionTagList?.find((i: { dispositionName: any }) => i.dispositionName === 'Closed');
      const data: any = {
        domainId: loginUserCcaasDetail.domainId,
        ext: loginUserCcaasDetail.ext,
        sessionId: currentSession.sessionId,
        summary: null,
        disposition: mapData(dis),
        dispositionName: 'Closed',
        afterCallWorkTime: 0,
        calledPersonDetails: currentSession?.calledPersonDetails ?? {},
        subject: null,
        updateAt: Date.now(),
        channelType: currentSession?.channelType ? currentSession?.channelType : currentSession?.channeltype ? currentSession?.channeltype : currentSession?.ChatHistoryId ? 'Chat' : null,
        ChatDurationHistoryId: currentSession?.ChatDurationHistoryId,
        dispositionId: dis?.did,
        agentOccupyDetails: null,
        isTicketing: false,
        isSessionClosed: 1,
        afterWorkTime: 0,
        dispositionUpdatedBy: loginDetails.UserID,
        duration: currentSession?.sessionOnGoingTime,
        dispositionSubject: null,
        WhatsappHistoryId: currentSession?.WhatsappHistoryId,
        FacebookHistoryId: currentSession?.FacebookHistoryId,
        InstagramHistoryId: currentSession?.InstagramHistoryId,
      };

      const stringifiedData = JSON.stringify(data);
      console.log('Sending API request before unload', data);
      navigator.sendBeacon(`${CALLURL}/update_disposition_beforeunload`, stringifiedData);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("unload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("unload", handleUnload);
    };
  }, []);

  useEffect(() => {
    if (currentSession?.sessionId) {
      getData();
    } else {
      if (PRIVILLEGED_ROLES.includes(roleId)) {
        navigate("/AllActivity");
      } else if (roleId == ROLES.SUPERVISOR_ROLE_ID) {
        navigate("/allactivity");
      } else {
        navigate("/myactivity");
      }
    }
  }, [currentSession?.sessionId]);


  const isMobile = useMediaQuery({ maxWidth: 1023 });
  const isTab = useMediaQuery({ maxWidth: 1199 });

  useEffect(() => {
    if (isMobile) {
      dispatch(ChatActions.setViewProfile(false));
      dispatch(ChatActions.setInternalAssist(false));
    } else if (isTab) {
      dispatch(ChatActions.setViewProfile(false));
      dispatch(ChatActions.setInternalAssist(true));
    }
    else {
      dispatch(ChatActions.setViewProfile(true));
      dispatch(ChatActions.setInternalAssist(true));
    }
  }, [isMobile, isTab])
  const Menucollapse: any = useSelector((state: any) => state.sideBar.Menucollapse);



  return (
    <>
      <Layout className="scrollbarmain chatscreenscroll autochatscroll">
        {currentSession?.isInteractionView
          ? <Layout>
            <Content className="chatInner chatbarscroll" id="chatWindow">
              <ViewInteractions />
            </Content>
          </Layout>
          : (chatReducer.updateProfileContact === false) && (
            <Layout>
              {chatReducer.viewProfile &&
                <Sider className={`leftSideBar ${Menucollapse ? 'expandlefsidebar' : ''}`}>
                  <ChatLeftSideBar />
                </Sider>}
              <Content className="chatInner chatbarscroll" id="chatWindow">
                <ChatMainInner />
              </Content>
              {chatReducer.internalAssist && <>
                {((currentSession?.dispositionId === null || currentSession?.DispositionId === null) || !agentvideo) ?

                  <Sider style={{ overflow: "hidden" }} className="rightSideBar scroller chatbarscroll agentassistRight meetaiassist">

                    <ChatRightSideBar />
                  </Sider> : <Sider className="rightSideBar scroller chatbarscroll agentassistRight meetaiassist">

                    {componentState === "internalChat" ? <ChatRightSideBar /> : componentState === "meetTranscription" ? <MeetTranscription /> : componentState === "meetChat" ? <VideoMeetingChat /> : <ChatRightSideBar />}
                  </Sider>}</>}

            </Layout>
          )
        }
      </Layout>
    </>
  );
}
export default WebChatScreen;
